import React from 'react';
import Icon, { type IconName } from '../Icon';

interface Props {
  icon: IconName;
  title: string;
  sub?: string;
  action?: React.ReactNode;
}

/** Standard empty state: icon tile + title + sub + optional CTA. */
const Empty: React.FC<Props> = ({ icon, title, sub, action }) => (
  <div className="empty">
    <div className="empty-ico">
      <Icon name={icon} size={30} />
    </div>
    <div className="card-title">{title}</div>
    {sub && <div className="muted" style={{ marginTop: 6 }}>{sub}</div>}
    {action && <div className="mt-16">{action}</div>}
  </div>
);

export default Empty;
